import api, {deleteFn, getFn, IdApiArg, insertFn, UpdateArg, updateFn, UpdateResp} from "../../api";
import {Tables, TablesInsert, TablesUpdate} from "../../apitypes";
import {supabase} from "../../supabase";

export interface MachineFilter {
    active?: boolean
}

export const peopleApi = api.injectEndpoints({
    endpoints: (build) => ({
        // Machine types
        getMachine: build.query<Tables<"machine">[], MachineFilter>({
            queryFn: async (args) => {
                const q = supabase
                    .from("machine")
                    .select("*")
                if (args.active === true || args.active === false) {
                    q.eq("Active", args.active)
                }
                const {data, error} = await q;

                if (error) return {error};
                return {data}
            },
            providesTags: ["Machine"]
        }),
        getMachineById: build.query<MachineApiGet | null, IdApiArg>({
            query: getFn("machine"),
            providesTags: ["Machine"]
        }),
        postMachine: build.mutation<UpdateResp, TablesInsert<"machine">>({
            query: insertFn("machine"),
            invalidatesTags: ["Machine"],
        }),
        deleteMachineById: build.mutation<UpdateResp, IdApiArg>({
            query:deleteFn("machine"),
            invalidatesTags: ["Machine"],
        }),
        putMachineById: build.mutation<UpdateResp, UpdateArg<"machine">>({
            query: updateFn("machine"),
            invalidatesTags: ["Machine"],
        }),

    })
});


export type MachineApiGet = Tables<"machine">
export type MachineApiPut = Omit<TablesUpdate<"machine"> & {workTask: Tables<"workTask">|null}, "created_at" | "updated_at" | "id">


export const {
    useGetMachineQuery,
    useGetMachineByIdQuery,
    usePostMachineMutation,
    usePutMachineByIdMutation,
    useDeleteMachineByIdMutation,

} = peopleApi;
